import _ from 'lodash';
import { getCurrentAuthToken } from '../components/context/AuthContext';
import MetadataService from '../service/MetadataService';

const sessionStartTimeMs = new Date().getTime();
let initialized = false;
let initializationStarted = false;
let userEmail = undefined;
let queuedEvents = [];

function initialize() {
  if (initializationStarted) {
    return;
  }

  const authToken = getCurrentAuthToken();
  if (authToken) {
    initializationStarted = true;
    userEmail = 'AUTHENTICATED_USER'; // We don't have easy access to email from token
    initialized = true;
  } else {
    userEmail = 'UNKNOWN';
    initialized = true;
  }
}

function logEvent(eventName, errorMsg = '', params = {}) {
  queuedEvents.push(constructEvent(eventName, errorMsg, params));
  if (!initialized) {
    initialize();
    return;
  }
  MetadataService.sharedInstance().ingestAnalytics(queuedEvents);
  queuedEvents = [];
}

function constructEvent(eventName, error_message = '', params = {}) {
  return {
    user_id: userEmail,
    event_type: eventName,
    platform: 'Web',
    session_id: sessionStartTimeMs,
    timestamp: new Date().getTime(),
    event_properties: {
      params: params,
      error_message,
    },
  };
}

export { logEvent };
